import { IftuneConfView } from "@/admin/vm/IftuneConfView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/vm_conf")({
    component: IftuneConfView,
});
